// ABOUTME: Settings view on the relation Email settings page.
// ABOUTME: Lets the relation set the mail button colors used in its outgoing mails (e.g. track & trace).

import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import EmailButtonColorSettings, {
    DEFAULT_EMAIL_BUTTON_COLOR,
    DEFAULT_EMAIL_BUTTON_TEXT_COLOR,
} from "../../../../../components/global/EmailTemplates/EmailButtonColorSettings";
import {
    useGetSettingsForRelationQuery,
    useUpdateSettingForRelationMutation,
} from "../../../../../newapi/global/generalApiSlice";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";

const BUTTON_COLOR_KEY = "email_button_color";
const BUTTON_TEXT_COLOR_KEY = "email_button_text_color";

const EmailSettings = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const hasManagePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_COMPANY_INFO_MANAGE])
    );

    const environment = useSelector((state) => state.settings.environment);
    const relationId = environment.selectedId;

    const { data: settingsData } = useGetSettingsForRelationQuery(relationId, { skip: !relationId });
    const [updateSettingForRelation] = useUpdateSettingForRelationMutation();

    useEffect(() => {
        props.replaceView({
            ...props.config,
        });
    }, []);

    const settings = settingsData?.data ?? settingsData ?? [];

    const getSetting = (key) => settings.find((setting) => setting.key === key);

    const saveColor = (key) => (value) => {
        updateSettingForRelation({
            key,
            value,
            relationId,
        });
    };

    return (
        <Box
            sx={{
                height: 1,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    width: 1,
                    overflow: "auto",
                    background:
                        theme.palette.mode === "dark"
                            ? colors.grey[300]
                            : colors.bg["tertiary"],
                    paddingX: 3,
                    paddingTop: 4,
                    paddingBottom: 4,
                    height: 1,
                    position: "relative",
                    borderTopLeftRadius: 24,
                    borderTopRightRadius: 24,
                    "@media screen and (max-width: 47.9375em)": {
                        paddingTop: 2,
                        paddingX: 2,
                        background: colors.bg["tertiary"],
                    },
                }}
            >
                <EmailButtonColorSettings
                    buttonColor={getSetting(BUTTON_COLOR_KEY)?.value ?? DEFAULT_EMAIL_BUTTON_COLOR}
                    buttonTextColor={getSetting(BUTTON_TEXT_COLOR_KEY)?.value ?? DEFAULT_EMAIL_BUTTON_TEXT_COLOR}
                    onButtonColorChange={saveColor(BUTTON_COLOR_KEY)}
                    onButtonTextColorChange={saveColor(BUTTON_TEXT_COLOR_KEY)}
                    disabled={!hasManagePermission}
                />
            </Box>
        </Box>
    );
};

export default EmailSettings;
